import React from "react";
import "../../pages/Machine.css";

const MachineForm = ({
  formData,
  editingMachine,
  onInputChange,
  onSubmit,
  onClose,
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <h2>{editingMachine ? "Edit Machine" : "Add New Machine"}</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={onSubmit} className="modal-body">
          <div className="form-group">
            <label>Machine ID:</label>
            <input
              type="text"
              name="machine_id"
              value={formData.machine_id}
              onChange={onInputChange}
              required
              className="form-control"
              readOnly={!editingMachine}
              title={
                !editingMachine
                  ? "Machine ID is automatically generated and cannot be changed"
                  : "Edit Machine ID"
              }
            />
            {!editingMachine && (
              <small className="form-help-text">
                Machine ID is automatically generated using device fingerprint
              </small>
            )}
          </div>
          <div className="form-group">
            <label>Machine Name:</label>
            <input
              type="text"
              name="machine_name"
              value={formData.machine_name}
              onChange={onInputChange}
              required
              className="form-control"
              placeholder="Enter machine name"
            />
          </div>
          <div className="form-group">
            <label>Description:</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={onInputChange}
              className="form-control"
              rows="3"
              placeholder="Enter machine description"
            />
          </div>
          <div className="form-group">
            <label>
              <input
                type="checkbox"
                name="is_active"
                checked={formData.is_active}
                onChange={onInputChange}
              />
              Active
            </label>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {editingMachine ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MachineForm;